export default "__VITE_ASSET__Ddok93T9__"